module.exports = __webpack_public_path__ + "img/76.ce9f59a4.jpg";